import axios from "axios";
import authHeader from '../../../authheader'

const LSIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualLsiApplication";

const getContactInformation = (applicationId) => {
    return axios.get(`${LSIAPPLICATIONURL}/contactinformation`, { headers: authHeader(), params: {applicationId} });
}
const postContactInformation = (applicationId, certDisplayName) => {
    return axios.post(`${LSIAPPLICATIONURL}/contactinformation`, null, { headers: authHeader(), params: { applicationId, certDisplayName } });
}
export default {
    getContactInformation,
    postContactInformation
}